import { Card, Dropdown } from "react-bootstrap";
import SKPChart from "../components/skp-chart-2";

export default function SKPSection({
  data,
  totalSKP,
  limit,
  onChangeLimit,
  thn
}) {
  return (
    <Card className="h-400 shadow-sm rounded-3 mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center">
        <h6 className="fw-bold text-uppercase mb-0">
          Grafik SKP Per Propinsi
        </h6>
        <Dropdown onSelect={(v) => onChangeLimit(Number(v))}>
          <Dropdown.Toggle size="sm" variant="light"> Top {limit}
          </Dropdown.Toggle>
          <Dropdown.Menu> {[5, 10, 15, 20].map((v) => (
            <Dropdown.Item key={v} eventKey={v}> Top {v}
            </Dropdown.Item>))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>
      <Card.Body>
        {data?.length ? (<SKPChart rekapSKP={data} />) : (<div className="text-center text-muted py-4"> 📭 Data belum tersedia pada periode ini </div>)}
        <div className="d-flex flex-wrap gap-2 align-items-center justify-content-center mt-1">
          <div className="d-flex">
            <span className="badge bg-success px-2 py-1 fs-7 fw-semibold rounded-start">
              Total SKP Terbit
            </span>
            <span className="badge bg-light text-dark px-2 py-1 fs-7 fw-semibold border border-success rounded-end">
              {totalSKP?.toLocaleString("id-ID")}
            </span>
          </div>
        </div>
      </Card.Body>
    </Card>);
}